module.exports = require('aphrodite/no-important');
